export class CatalogueData {
  public static data = [
    {id: 'frecuency', valor: 15},
    {id: 'unidad', valor: 21},
    {id: 'frecuencyActividad', valor: 24},
    {id: 'contract', valor: 33},
  ];
}

